import { ApiService } from '../../../ApiService';
import { HrisSuggestions } from '../../../../entities/v1/HrisSuggestions';

export class HrisSuggestionsService {
  public static get(applicationId: number): Promise<HrisSuggestions> {
    return ApiService.get<HrisSuggestions>(
      `/api/v1/applicant_tracking/applications/${applicationId}/hris_suggestions`,
    );
  }
}
